
const initialState = {
    bankListLoading: false,
    bankListData: null,
    bankListError: null,
    bankListStatus: null,
    isModified: false,
    isFirstLoad: true,
    selectedUserBankList: null


};

const userBankListReducer = (state = initialState, action) => {
    switch (action.type) {

        case 'GET_BANK_LIST_REQUEST':
            return { ...state, bankListLoading: state.isFirstLoad };
        case 'GET_BANK_LIST':
            return {
                bankListLoading: false, bankListData: action.payload, bankListError: null, bankListStatus: true,

                isFirstLoad: false,
            };

        case 'GET_BANK_LIST_ERROR':
            return { bankListLoading: false, bankListData: null, bankListError: action?.payload, bankListStatus: false, isFirstLoad: false, };
        case 'UPDATE_BANK_LIST_DATA':
            return {
                ...state,
                bankListData: {
                    ...state.bankListData,
                    result: {
                        ...state.bankListData.result,
                        ...action.payload,
                    },
                },
            };
        case 'REMOVE_BANK_LIST_DATA':
            return { ...state, bankListData: null, bankListError: null, isModified: false, bankListStatus: null, isFirstLoad: true, bankListLoading: false, selectedUserBankList: null }

        case 'SET_SELECTED_BANK_LIST':
            return { ...state, selectedUserBankList: action.payload }
        default:
            return state;
    }
};

export default userBankListReducer;